import ConfiguredRoute from './ConfiguredRoute.component';
export default ConfiguredRoute;
